export default __webpack_public_path__ + "static/media/bloodflow.035def23.png";